import React, { useEffect, useRef, useState } from "react";
import { TextField, InputLabel, MenuItem } from "@mui/material";
import { TbPhotoPlus } from "react-icons/tb";
import { FaAngleLeft } from "react-icons/fa";
import { MdModeEdit, MdDelete } from "react-icons/md";
import { IoIosAddCircle } from "react-icons/io";
import { Button, message, Radio, Checkbox, Modal, Switch } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  post_Delivery_partner,
  validateEmail,
  validateMobile,
  validateValiId,
} from "../../redux/delivery_partner/DeliveryPartnerSlice";

const Create_delivery_partner = () => {
  const dispatch = useDispatch();

  const [messageApi, contextHolder] = message.useMessage();

  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [emailvalid, setemailvalid] = useState("");
  const [emailError, setemailError] = useState("");
  const [number, setnumber] = useState("");
  const [numbervalid, setnumbervalid] = useState("");
  const [numberError, setnumberError] = useState("");
  const [licence, setlicence] = useState("");
  const [licencevalid, setlicencevalid] = useState("");
  const [licenceError, setlicenceError] = useState("");
  const [address, setaddress] = useState("");
  const [button_press, setbutton_press] = useState(false);

  useEffect(() => {
    if (button_press === true) {
      if (emailvalid === "") {
        setemailError("Enter valid Email");
      } else {
        setemailError("");
      }
      if (numbervalid.length !== 10) {
        setnumberError("Enter valid number");
      } else {
        setnumberError("");
      }
      if (licencevalid === "") {
        setlicenceError("Enter valid number");
      } else {
        setlicenceError("");
      }
    }
  }, [button_press, emailvalid, numbervalid, licencevalid]);

  const check_email = async (e) => {
    const value = e.target.value.trim();
    const emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;
    const email_Regex = /@[a-z]/;
    const emailtotalRegex = /.[a-z]{2,3}/;
    setemail(value);
    setemailError("");
    if (!email_Regex.test(value)) {
      setemailError("email address @ is missing like examplegmail.com");
    } else if (!emailtotalRegex.test(value)) {
      setemailError("email address domain is missing like example@");
    } else if (!emailRegex.test(value)) {
      setemailError("*Error! you have entered invalid email.");
    } else {
      const verifyemail = await dispatch(validateEmail(value));
      if (verifyemail.payload.success === true) {
        setemailError("Email already exits");
      } else {
        setemailvalid(value);
        setemailError("");
      }
    }
  };
  const check_Mobile = async (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setnumber(value);
    setnumberError("");
    if (value.length === 10) {
      const verify = await dispatch(validateMobile(value));
      if (verify.payload.success === false) {
        setnumbervalid(value);
        setnumberError("");
      } else {
        setnumbervalid("");
        setnumberError(verify.payload.message);
      }
    } else {
      setnumberError("Number must should be a 10 chars");
    }
  };
  const check_licences = async (e) => {
    const value = e.target.value.trim();
    setlicence(value);
    setlicenceError("");
    if (value !== "") {
      const verify = await dispatch(validateValiId(value));
      if (verify.payload.success === false) {
        setlicencevalid(value);
        setlicenceError("");
      } else {
        setlicencevalid("");
        setlicenceError(verify.payload.message);
      }
    } else {
      setlicenceError("Please enter valid Id");
    }
  };

  const handlePartnerPress = async () => {
    setbutton_press(true);
    if (
      name !== "" &&
        emailvalid !== "" &&
        numbervalid !== "" &&
        address !== "" &&
        licencevalid !== ""
    ) {
      const formdata = {
        name: name,
        mobile: numbervalid,
        email: emailvalid,
        valid_id: licencevalid,
        address: address,
      };
      const form_posting = await dispatch(post_Delivery_partner(formdata));
      if (form_posting.payload.success === true) {
        messageApi.open({
          type: "success",
          content: `Partner add Successfully`,
        });

        setname("");
        setemail("");
        setemailvalid("");
        setemailError("");
        setnumber("");
        setnumbervalid("");
        setnumberError("");
        setlicence("");
        setlicencevalid("");
        setlicenceError("");
        setaddress("");
        setbutton_press(false);
      }
    }
  };

  const input_lable_style = {
    color: "#1a1a1a",
    fontSize: "0.75rem",
    fontWeight: "800",
    marginBottom: "0.5vh",
    textTransform: "uppercase",
  };
  return (
    <>
      {contextHolder}
      <div className="add_page_main">
        <div className="add_hedaer_main_cnf">
          <div className="add_page_header">
            <h4>Add Delivery Partner</h4>
            {/* <Link to="/restaurant/product-list"> */}
            <div className="bac_add_nav">
              <span>
                <FaAngleLeft color="#333333" />
              </span>
              <h6>Partner List</h6>
            </div>
            {/* </Link> */}
          </div>
        </div>
        <div className="add_input_box_main">
          <div className="add_page">
            <div className="input_container">
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Name <sup className="star_colour">*</sup>
                </InputLabel>
                <TextField
                  id="custom-input"
                  placeholder="Enter Name"
                  variant="outlined"
                  error={name === "" && button_press === true ? true : false}
                  helperText={
                    name === "" && button_press === true ? "Required" : ""
                  }
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  onChange={(e) =>
                    setname(
                      e.target.value.replace(/\b\w/g, (char) =>
                        char.toUpperCase()
                      )
                    )
                  }
                  value={name}
                  InputProps={{
                    style:
                      name === "" && button_press === true
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                />
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Email <sup className="star_colour">*</sup>
                </InputLabel>
                <TextField
                  id="custom-input"
                  placeholder="Enter Email"
                  variant="outlined"
                  error={emailError !== "" ? true : false}
                  helperText={emailError}
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  onChange={(e) => check_email(e)}
                  value={email}
                  InputProps={{
                    style:
                      emailError !== ""
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                />
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Number <sup className="star_colour">*</sup>
                </InputLabel>
                <TextField
                  id="custom-input"
                  placeholder="Enter Number"
                  variant="outlined"
                  error={numberError !== "" ? true : false}
                  helperText={numberError}
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  onChange={(e) => check_Mobile(e)}
                  value={number}
                  InputProps={{
                    style:
                      numberError !== ""
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                  inputProps={{
                    minLength: 10,
                    maxLength: 10,
                  }}
                />
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Id <sup className="star_colour">*</sup>
                </InputLabel>
                <TextField
                  id="custom-input"
                  placeholder="Enter Id"
                  variant="outlined"
                  error={licenceError !== "" ? true : false}
                  helperText={licenceError}
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  onChange={(e) => check_licences(e)}
                  value={licence}
                  InputProps={{
                    style:
                      licenceError !== ""
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                />
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Address <sup className="star_colour">*</sup>
                </InputLabel>
                <TextField
                  id="custom-multiline-input"
                  multiline
                  rows={4}
                  placeholder="Enter Address"
                  variant="outlined"
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  error={button_press === true && address === "" ? true : false}
                  helperText={
                    button_press === true && address === ""
                      ? "Enter Address"
                      : ""
                  }
                  onChange={(e) =>
                    setaddress(
                      e.target.value.replace(/\b\w/g, (char) =>
                        char.toUpperCase()
                      )
                    )
                  }
                  value={address}
                  InputProps={{
                    style:
                      button_press === true && address === ""
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                />
              </div>
              <div className="submit_btn_container">
                <Button
                  className="confirm_btn sub_padding"
                  onClick={() => handlePartnerPress()}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Create_delivery_partner;
